import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 防止外部code影響內部
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
});